import { EditIcon } from '@chakra-ui/icons';
import { MenuItem } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

import { Text } from '@/components/v4';
import { IconComponent } from 'pages/dashboards/v5/components/IconComponent';

import path from '@/routes/constants';

import { ACS, DIRECT_ROUTING, GCC_HIGH, OPERATOR_CONNECT } from '../constants';

const EditServiceMenuItem = ({
    accountScope,
    actionPermissions,
    cardStatus,
    darkMode,
    service,
    serviceObj,
}) => {
    switch (service?.serviceType) {
        case ACS: {
            const acsServiceId =
                service?.id || service?.serviceId || service?.serviceID;
            return (
                <Link
                    className="bg-transparent !no-underline hover:text-inherit"
                    to={`/services/acsservice/${acsServiceId}/edit`}
                    state={{ serviceId: acsServiceId }}>
                    <MenuItem icon={<EditIcon />}>
                        <Text marginBottom="0">Edit Service</Text>
                    </MenuItem>
                </Link>
            );
        }
        case OPERATOR_CONNECT: {
            const ocServiceId =
                service?.id || service?.serviceId || service?.serviceID;
            return (
                cardStatus?.showEdit &&
                accountScope >= actionPermissions.menuEditServiceScope && (
                    <Link
                        id="edit-oc-service"
                        className="bg-transparent !no-underline hover:text-inherit"
                        to={`${path.SERVICES_OPERATOR_CONNECT}/${ocServiceId}/edit`}
                        state={serviceObj}>
                        <MenuItem
                            icon={
                                <IconComponent
                                    icon="Edit"
                                    color={darkMode ? 'white' : 'black'}
                                />
                            }
                            data-walkthroughid={`/dashboard-services/card/${service.name}/edit-service`}>
                            <Text marginBottom="0">Edit Service</Text>
                        </MenuItem>
                    </Link>
                )
            );
        }
        case DIRECT_ROUTING: {
            const drServiceId =
                service?.id || service?.serviceId || service?.serviceID;
            const drMenuEditServiceScope = 20;
            return (
                accountScope >= drMenuEditServiceScope &&
                cardStatus?.showEdit && (
                    <Link
                        id="edit-dr-service"
                        className="bg-transparent !no-underline hover:text-inherit"
                        to={`${path.SERVICES_DIRECT_ROUTING}/${drServiceId}/edit`}
                        state={serviceObj}>
                        <MenuItem
                            icon={<EditIcon />}
                            data-walkthroughid={`/dashboard-services/card/${service.name}/edit-service`}>
                            <Text marginBottom="0">Edit Service</Text>
                        </MenuItem>
                    </Link>
                )
            );
        }
        case GCC_HIGH: {
            const gccServiceId =
                service?.id || service?.serviceId || service?.serviceID;
            return (
                accountScope >= actionPermissions?.menuEditServiceScope &&
                cardStatus?.showEdit && (
                    <Link
                        id="edit-gcc-service"
                        className="bg-transparent !no-underline hover:text-inherit"
                        to={`${path.SERVICES_DIRECT_ROUTING_GCCHIGH}/${gccServiceId}/edit`}
                        state={serviceObj}>
                        <MenuItem
                            icon={<EditIcon />}
                            data-walkthroughid={`/dashboard-services/card/${service.name}/edit-service`}>
                            <Text marginBottom="0">Edit Service</Text>
                        </MenuItem>
                    </Link>
                )
            );
        }

        default:
            return null;
    }
};

export default EditServiceMenuItem;
